import { calculatePickingColors } from './geojson-binary';

function createEmptyLayerProps() {
  return {
    points: {},
    lines: {},
    polygons: {},
    polygonsOutline: {}
  };
}

function getCoordinates(f) {
  return f.geometry.coordinates;
}

export function createLayerPropsFromFeatures(features, featuresDiff) {
  var layerProps = createEmptyLayerProps();
  var pointFeatures = features.pointFeatures,
      lineFeatures = features.lineFeatures,
      polygonFeatures = features.polygonFeatures,
      polygonOutlineFeatures = features.polygonOutlineFeatures;
  layerProps.points.data = pointFeatures;

  layerProps.points._dataDiff = featuresDiff.pointFeatures && function () {
    return featuresDiff.pointFeatures;
  };

  layerProps.points.getPosition = getCoordinates;
  layerProps.lines.data = lineFeatures;

  layerProps.lines._dataDiff = featuresDiff.lineFeatures && function () {
    return featuresDiff.lineFeatures;
  };

  layerProps.lines.getPath = getCoordinates;
  layerProps.polygons.data = polygonFeatures;

  layerProps.polygons._dataDiff = featuresDiff.polygonFeatures && function () {
    return featuresDiff.polygonFeatures;
  };

  layerProps.polygons.getPolygon = getCoordinates;
  layerProps.polygonsOutline.data = polygonOutlineFeatures;

  layerProps.polygonsOutline._dataDiff = featuresDiff.polygonOutlineFeatures && function () {
    return featuresDiff.polygonOutlineFeatures;
  };

  layerProps.polygonsOutline.getPath = getCoordinates;
  return layerProps;
}
export function createLayerPropsFromBinary(geojsonBinary, uniqueIdProperty, encodePickingColor) {
  var layerProps = createEmptyLayerProps();
  var points = geojsonBinary.points,
      lines = geojsonBinary.lines,
      polygons = geojsonBinary.polygons;
  var customPickingColors = calculatePickingColors(geojsonBinary, uniqueIdProperty, encodePickingColor);
  layerProps.points.data = {
    length: points.positions.value.length / points.positions.size,
    attributes: {
      getPosition: points.positions,
      pickingColors: {
        size: 3,
        value: customPickingColors.points
      }
    },
    properties: points.properties,
    numericProps: points.numericProps,
    featureIds: points.featureIds
  };
  layerProps.lines.data = {
    length: lines.pathIndices.value.length - 1,
    startIndices: lines.pathIndices.value,
    attributes: {
      getPath: lines.positions,
      pickingColors: {
        size: 3,
        value: customPickingColors.lines
      }
    },
    properties: lines.properties,
    numericProps: lines.numericProps,
    featureIds: lines.featureIds
  };
  layerProps.lines._pathType = 'open';
  layerProps.polygons.data = {
    length: polygons.primitivePolygonIndices.value.length,
    startIndices: polygons.primitivePolygonIndices.value,
    attributes: {
      getPolygon: polygons.positions,
      pickingColors: {
        size: 3,
        value: customPickingColors.polygons
      }
    },
    properties: polygons.properties,
    numericProps: polygons.numericProps,
    featureIds: polygons.featureIds
  };
  layerProps.polygons._normalize = false;
  layerProps.polygonsOutline.data = {
    length: polygons.primitivePolygonIndices.value.length,
    startIndices: polygons.primitivePolygonIndices.value,
    attributes: {
      getPath: polygons.positions,
      instancePickingColors: {
        size: 3,
        value: customPickingColors.polygons
      }
    },
    properties: polygons.properties,
    numericProps: polygons.numericProps,
    featureIds: polygons.featureIds
  };
  layerProps.polygonsOutline._pathType = 'open';
  return layerProps;
}
//# sourceMappingURL=geojson-layer-props.js.map


// WEBPACK FOOTER //
// ./~/@deck.gl/layers/dist/esm/geojson-layer/geojson-layer-props.js